module.exports = __webpack_public_path__ + "img/ktb.352a71d4.svg";